import {Component, OnDestroy, OnInit} from '@angular/core';
import {CoreApiService} from "../../service/core-api.service";
import {Router} from "@angular/router";
import {AuthService} from "../../service/auth.service";
import {RegistrationApiService} from "../../../rg/api/registration-api.service";
import {
  ForgotPasswordDto,
  ForgotPasswordOptionEnum,
  ForgotPasswordOtpOptionDto,
  ForgotPasswordRequestDto,
} from "../../../rg/types/registration.types";
import {UserApiService} from "../../../cross/user/api/user-api.service";
import {CustomerOnboardingInternalStatus} from "../../../cross/user/types/user.types";
import {AppMessageService} from "../../service/app-message.service";
import {MessageHelper} from "../../helper/message-helper";

@Component({
    selector: 'mvs-example',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit, OnDestroy {

    busy: boolean = false;  // indicator whether the component is busy
    initialized: boolean = false; // indicator whether the component was initialized

    email: string = "";  //= "a@gmail.com";
    password: string = ""; // = "123456@aA";
    visible: boolean = false;

    forgotPasswordOptions: ForgotPasswordOtpOptionDto[] | undefined;
    forgotPasswordDto: ForgotPasswordDto | undefined;
    selectedOption: ForgotPasswordOptionEnum | undefined;

    constructor(
        protected authService: AuthService,
        protected registrationApiService: RegistrationApiService,
        protected coreApiService: CoreApiService,
        protected userApiService: UserApiService,
        protected messageService: AppMessageService,
        protected router: Router) {
    }

    ngOnInit(): void {
        this.initComponent();

    }

    handleLogin() {

      if (this.busy) {
        return;
      }

      this.busy = true;


      this.authService.login(this.email?.toLowerCase(), this.password).subscribe(value => {

        // check where to navigate to
        this.userApiService.getBasicData().subscribe(response => {

          this.busy = false;

          if (response.onboardingOnRegistrationStatus == CustomerOnboardingInternalStatus.missing) {
            this.router.navigate(["/ob/start"]);
          } else if (response.onboardingOnRegistrationStatus == CustomerOnboardingInternalStatus.pending) {
            this.router.navigate(['/ob/start'], { queryParams: { continue: 'true' } });
          } else if (response.onboardingOnRegistrationStatus == CustomerOnboardingInternalStatus.appointment_missing) {
            this.router.navigate(["/ob/start/4"]);
          } else {
            this.router.navigate(["/ds/home"]);
          }

        });

      }, error => {
          // this.messageService.showErrorMessage("", "Email oder Passwort sind falsch. Bitte erneut eingeben!");
          MessageHelper.showErrorMessage("Email oder Passwort sind falsch. Bitte erneut eingeben!", this.messageService)
          this.busy = false;
      });

    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();
    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.initialized = true;
    }

  showDialog() {
    this.visible = true;
  }
    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }

  navigateToRegistration() {
      this.router.navigate(['/sign-up'])
  }

  navigateToForgetPassword() {
    this.router.navigate(['/forget-password'])
  }
  navigateToLoginOtpCode() {
    this.router.navigate(['/login-otp-code'])
  }

}
